/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Diff_Type_AddedInputs */



/**
* | output |
* | --- |
* | "added" |
*
* @param {Compare_Event_Groups_Diff_Type_AddedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_diff_type_added = /** @type {((inputs?: Compare_Event_Groups_Diff_Type_AddedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Diff_Type_AddedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ajouté")
	if (locale === "de") return /** @type {LocalizedString} */ ("hinzugefügt")
	if (locale === "it") return /** @type {LocalizedString} */ ("aggiunto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("добавлен")
	if (locale === "es") return /** @type {LocalizedString} */ ("agregado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("额外")
	if (locale === "ja") return /** @type {LocalizedString} */ ("追加した")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जोड़ा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("adicionado")
	return /** @type {LocalizedString} */ ("added")
});